<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-reward-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <div class="dialog-body">
                </div>   
            </div>         
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            pack_config : [
                [{name : '',id : 'LQ44',num : 15},{name : '',id : 'LT15',num : 1},{name : '',id : 'KR54',num : 2},{name : '',id : 'E559',num : 2},{name : '',id : 'LQ57',num : 50}],
                [{name : '',id : 'LK09',num : 1},{name : '',id : 'LE95',num : 10},{name : '',id : 'X472',num : 20},{name : '',id : 'D774',num : 5},{name : '',id : 'X230',num : 100}],
                [{name : '',id : 'E246',num : 1},{name : '',id : 'X230',num : 100},{name : '',id : 'D774',num : 2},{name : '',id : 'X472',num : 10},{name : '',id : 'D355',num : 2}]
            ],
        }
    }, 
    methods : {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },      
    },
}
</script>

<style scoped>
/* share */
.m-reward-modal{
    width: 663px;
    height: 942px;
    background-image: url(~@/assets/images/utils/modal-luck.png);
}

.m-reward-modal .u-btn.close{
    width: 34px;
    height: 34px;
    top: 115px;
    right: 0;
    background-image: url(~@/assets/images/utils/btn-close_2.png);
}

@media screen and (min-width: 1001px) {
    .m-reward-modal{
    width: 572px;
    height: 800px;
    background-image: url(~@/assets/images/utils/modal-luck_pc.png);
}

.m-reward-modal .u-btn.close{
    top: 95px;
}
}
</style>


// WEBPACK FOOTER //
// src/components/LuckModal/luckModal.vue